import { API_ROUTES } from 'utils/constants';
import { RequestHelper } from 'utils';

const getLabels = (locale) => RequestHelper.GET(API_ROUTES.TRANSLATIONS(locale));

export const I18nService = {
  getLabels
};